module.exports = __webpack_public_path__ + "img/icon_contact_08.4a6a82c.svg";